import { Skeleton } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiFillQuestionCircle } from 'react-icons/ai';
import { ReactSVG } from 'react-svg';
import Button from '../../Component/Button/Button';
import SideBarSkeleton from '../../Component/SideBarSkeleton';
import StatsCard from '../../Component/StatsCard';
import {
  Coin,
  DashboardCardImg1,
  EventSlot,
  People,
  ProjectsIcon,
  PropertiesIcon,
  multiPeopleImg
} from '../../constant/imagePath';
import ContactSales from '../../modals/ContactSalesModal';
import { useGetCompanyDashboardQuery } from '../../store/apiSlice/apiSlice';
import classes from './CompanyDashboard.module.css';

function CompanyDashboard() {
  const { t: d } = useTranslation('dashboard');
  const t = (key) => d(`company.${key}`);
  const { isLoading, data } = useGetCompanyDashboardQuery();
  const [showContact, setShowContact] = useState(false);

  const stats = [
    {
      current: data?.propertyCount,
      icon: PropertiesIcon,
      background: '#D3E0B2',
      barColor: '#A5BF46',
      label: t('properties'),
      barTitle1: t('premiumListings'),
      barTitle2: t('featuredListings'),
      isBar1Visible: true,
      isBar2Visible: true,
      premium: data?.propertyPercentagePremium,
      featured: data?.propertyPercentageFeatured
    },
    {
      current: data?.projectCount,
      icon: ProjectsIcon,
      background: '#F4E0B4',
      barColor: '#F7C04B',
      label: t('projects'),
      barTitle1: t('premiumListings'),
      barTitle2: t('featuredListings'),
      isBar1Visible: true,
      isBar2Visible: true,
      premium: data?.projectPercentagePremium,
      featured: data?.projectPercentageFeatured
    },
    {
      // title: 'Events Slots Used',
      total: 40,
      current: data?.eventCount,
      icon: EventSlot,
      background: '#93D7D2',
      barColor: '#03A998',
      label: t('events'),
      barTitle1: t('premiumListings'),
      barTitle2: t('featuredListings'),
      isBar1Visible: true,
      isBar2Visible: true,
      premium: data?.eventPercentagePremium,
      featured: data?.eventPercentageFeatured
    }
  ];

  const followerData = {
    title: t('followers'),
    current: data?.followers,
    icon: People,
    background: '#FFFFFF',
    backgroundImage: DashboardCardImg1
  };

  const agentsData = {
    title: t('agents'),
    current: data?.noOfAgents,
    icon: multiPeopleImg,
    background: '#FFFFFF',
    barColor: '#AD7999',
    isBar1Visible: true,
    barBgColor: 'rgb(232 227 227)'
  };

  return (
    <SideBarSkeleton>
      {data?.expireNotification && <div className={classes?.strip}>{t('expireNotification')}</div>}
      <Container className={classes.main}>
        <Row className={classes.row}>
          {isLoading
            ? new Array(3).fill(0).map((item, index) => (
                <Col md={4} key={`${item?._id}-${index}`}>
                  <Skeleton variant="rectangular" height={209} />
                </Col>
              ))
            : stats?.map((item, index) => (
                <Col md={4} key={`${item?._id}-${index}`}>
                  <StatsCard data={item} />
                </Col>
              ))}
          {isLoading ? (
            new Array(4).fill(0).map((item, index) => (
              <Col md={6} key={`${item?._id}-${index}`}>
                <Skeleton variant="rectangular" height={209} />
              </Col>
            ))
          ) : (
            <>
              <Col md={6}>
                <StatsCard
                  data={agentsData}
                  isShowRange={false}
                  mainClass={classes.agentCardMain}
                />
              </Col>
              <Col md={6}>
                <StatsCard data={followerData} isShowRange={false} />
              </Col>
              <Col md={6}>
                <div
                  className={classes.memberShipWrap}
                  // style={{
                  //   backgroundImage: `url(${DashboardCardImg2})`,
                  //   backgroundSize: 'cover',
                  //   backgroundPosition: 'center'
                  // }}
                >
                  <p className={classes.membership}>{t('membership')}</p>
                  <p className={classes.lite}>{data?.packageType}</p>
                  <p className={classes.valid}>
                    {t('validTill')} {moment(data?.packageEndDate).format('Do MMM YYYY')}
                  </p>
                </div>
              </Col>
              <Col md={6}>
                <Row className={classes.creditMain}>
                  <Col md={6}>
                    <div className={classes.creditWrap}>
                      <div className={classes.head}>
                        <p>{t('availableCreditBalance')}</p>
                      </div>
                      <div className={classes.content}>
                        <p className={classes.amount}>{data?.availableCreditPoints}</p>
                        <ReactSVG src={Coin} />
                      </div>
                    </div>
                  </Col>
                  {/* <Col md={6} className={classes.purchaseBtnWrap}>
                <Button
                  className={classes.purchaseBtn}
                  leftIcon={<BsPlusCircleFill size={20} />}
                  label={'Purchase'}
                />
              </Col> */}
                </Row>
              </Col>
              <Col md={12} className={classes.contactBtn}>
                <Button
                  onClick={() => {
                    setShowContact(true);
                  }}
                  className={classes.purchaseBtn}
                  leftIcon={<AiFillQuestionCircle size={20} />}
                  label={t('contactSales')}
                />
              </Col>
            </>
          )}
        </Row>
        <ContactSales show={showContact} setShow={setShowContact} t={t} />
      </Container>
    </SideBarSkeleton>
  );
}

export default CompanyDashboard;
